<template>
	<div class="vote-container">
		<div v-if="!sentAnswers && !currentPoll" class="waiting-container middle-text">
			<p>Venter på at afstemningen åbnes.</p>
		</div>
		<div v-else-if="reachedEnd" class="middle-text">
			<p>
				Tak for jeres deltagelse!<br/>
				<br/>
				Vi ses næste år.
			</p>
		</div>
		<div class="confirm-screen no-choice-confirm-screen row mb-3" v-else-if="!sentAnswers && showNoChoiceConfirmScreen">
			<div class="middle-text">
				<p>
					Tiden er gået!
				</p>
				<p>Vil I sende jeres besvarelser alligevel?
				</p>
				<div class="button-container mt-5">
					<div class="container">
						<div class="row">
							<ist-button widthType="block" type="red" v-on:click="confirmAnswers(true)" :disabled="!canSendAnswers">Ja, send vores svar{{ sendingAnswers ? '..' : '' }}</ist-button>
						</div>
						<div class="row mt-3">
							<ist-button widthType="block" type="red" v-on:click="confirmAnswers(false)" :disabled="!canSendAnswers">Nej, send dem ikke{{ sendingAnswers ? '..' : '' }}</ist-button>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="confirm-screen row mb-3" v-else-if="!sentAnswers && showConfirmScreen">
			<div class="middle-text">
				<p>
					Vil I indsende jeres besvarelser til I Sandhedens Tjeneste?
				</p>
				<div class="button-container mt-5">
					<div class="container">
						<div class="row">
							<ist-button widthType="block" type="red" v-on:click="confirmAnswers(true)" :disabled="!canSendAnswers">Ja, send vores svar{{ sendingAnswers ? '..' : '' }}</ist-button>
						</div>
						<div class="row mt-3">
							<ist-button widthType="block" type="red" v-on:click="confirmAnswers(null)" :disabled="!canSendAnswers">Nej, vi vil lave dem om{{ sendingAnswers ? '..' : '' }}</ist-button>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div v-else-if="sentAnswers === true || sentAnswers === null" class="middle-text">
			<p>Tak for jeres besvarelse</p>
		</div>
		<div class="poll" v-else-if="sentAnswers === false">
			<div class="row-fluid header mb-3">
				<div class="text-center">Opgave {{ currentPollIndex + 1 }}</div>
			</div>
			<div class="row-fluid question mb-3">
				<p class="container-fluid question-text">
					{{ currentPoll.question }}
				</p>
			</div>
			<div class="row-fluid help-text mb-3" v-if="answersOpen && helpText">
				<p class="container-fluid" v-text="helpText" />
			</div>
			<div class="vote row-fluid mb-3" v-if="answersOpen">
				<div class="container" v-if="currentPoll.type === 'numeric'">
					<div class="row mb-3" v-for="(option, key) in options">
						<div class="col-7 col-sm-8 col-lg-9 poll-key">{{ options[key] }}</div>
						<div class="col poll-value">
							<select class="form-control form-control-lg numeric-dropdown" v-model="optionValues[key]">
								<option v-for="(n, i) in 36" :value="i" :key="i">{{ i }}</option>
							</select>
						</div>
					</div>
				</div>
				<div class="container freetext-container" v-else-if="currentPoll.type === 'freetext' || currentPoll.type === 'freetextWord'">
					<div class="row mb-4 poll-value" v-for="n in freetextCount" >
						<textarea class="form-control" rows="3" v-model="optionValues[indexToLetter(n)]" maxlength="140" />
					</div>

					<div class="row" v-if="canAddFreetext">
						<ist-button widthType="block" type="red" class="btn-add-freetext" v-on:click="addFreetext" v-if="addButtonText">{{ addButtonText }}</ist-button>
					</div>
				</div>
			</div>
			<div class="button-container row-fluid">
				<ist-button widthType="block" type="red" :disabled="!canSendAnswers" v-on:click="sendAnswers" v-if="answersOpen">Indsend svar
				</ist-button>
				<ist-button widthType="block" type="red"  :disabled="true" v-else>Venter på svarmuligheder</ist-button>
			</div>
		</div>
		<!--Your uid: {{ uid }}

		<div class="poll-info" v-if="currentPoll">
			Poll id: {{ currentPoll.id }}<br />
			Poll title: {{ currentPoll.question }}<br />
			Answers opened: {{ answersOpen ? 'yes' : 'no' }}<br />
		</div>-->
	</div>
</template>

<script>
	import * as MutationTypes from '@/store/mutation-types'
	import {mapGetters} from 'vuex';
	import IstButton from '@/components/buttons/IstButton.vue';

	export default {
		name: 'client-vote-vote',
		components: {IstButton},
		data() {
			return {
				currentPollIndex: null,
				answersOpen: null,

				options: [],
				optionValues: [],

				sendingAnswers: false,
				sentAnswers: false,

				reachedEnd: false,
				showConfirmScreen: false,
				showNoChoiceConfirmScreen: false,

				freetextCount: 1,
			}
		},
		mounted() {
			if (!this.uid) {
				this.$router.push('/client/register');

				return;
			}

			if (!this.sentAnswers && !this.currentPoll) {
			} else if (this.reachedEnd) {
			} else if (!this.sentAnswers && this.showNoChoiceConfirmScreen) {
			} else if (!this.sentAnswers && this.showConfirmScreen) {
			} else if (this.sentAnswers === true || this.sentAnswers === null) {
			}

			this.$echoClient.listenNewActivePoll(this.onNewActivePoll);
			this.$echoClient.listenAcceptAnswersUpdated(this.onAcceptAnswersUpdated);
			this.$echoClient.listenReachedEnd(this.onReachedEnd);

			this.$apiClient.loadGameData().then((data) => {
				this.reachedEnd = data.reachedEnd;

				this.setPollIndexByPollId(data.currentPollId);

				if (data.currentPollId) {
					this.answersOpen = data.acceptAnswers;
				} else {
					this.answersOpen = null;
				}

				console.log('data', data);
			});
		},
		computed: {
			...mapGetters({
				polls: 'getPolls',
				uid: 'getUid',
			}),
			currentPoll() {
				if (this.currentPollIndex === null) {
					return false;
				}

				return this.polls[this.currentPollIndex];
			},
			canSendAnswers() {
				if (this.sentAnswers) {
					return false;
				}

				if (this.sendingAnswers) {
					return false;
				}

				for (let key in this.optionValues) {
					let value = this.optionValues[key];

					if (this.currentPoll.type === 'numeric') {
						value = parseInt(value, 10);

						if (value > 0) {
							return true;
						}
					} else if (this.currentPoll.type === 'freetext' || this.currentPoll.type === 'freetextWord') {
						value = value.replace(/^\s+|\s+$/g, '');

						if (value !== '') {
							return true;
						}
					}
				}

				return false; // Fail by default
			},
			canAddFreetext() {
				return this.freetextCount < 5;
			},
			helpText() {
				if (!this.currentPoll) {
					return null;
				}

				let pollType = this.currentPoll.type;

				if (!pollType) {
					return null;
				}

				if (pollType === 'numeric') {
					return 'Angiv antal stemmer ud for hvert svar - hver elev har én stemme';
				} else if (pollType === 'freetext') {
					return 'I har mulighed for at tilføje op til fem spørgsmål (et spørgsmål i hvert felt)';
				} else if (pollType === 'freetextWord') {
					return 'I har mulighed for at tilføje op til fem ord (et ord i hver boks)';
				}
			},
			addButtonText() {
				if (!this.currentPoll) {
					return null;
				}

				let pollType = this.currentPoll.type;

				if (!pollType) {
					return null;
				}

				if (pollType === 'freetext') {
					return 'Tilføj spørgsmål';
				} else if (pollType === 'freetextWord') {
					return 'Tilføj ord';
				}
			}
		},
		methods: {
			indexToLetter(index) {
				let letters = 'ABCDEF';

				return letters[index];
			},
			addFreetext() {
				if (!this.canAddFreetext) {
					return;
				}

				this.freetextCount++;
			},
			confirmAnswers(confirmAnswers) {
				// confirmAnswers = true, yes; submit the answers
				// confirmAnswers = null, no; do not submit the answers
				// confirmAnswers = false, no; do not submit the answers but continue anyway
				console.log('confirmAnswers', confirmAnswers);
				if (this.sentAnswers === null || this.sentAnswers === true) {
					return;
				}

				if (this.sendingAnswers) {
					return;
				}

				if (confirmAnswers === true) {
					this.sendingAnswers = true;

					let uid = this.uid;
					let poll = this.currentPoll.id;
					let votes = [];

					for (let letter in this.optionValues) {
						votes.push(this.optionValues[letter]);
					}

					if (this.currentPoll.type === 'freetext') {
						votes = votes.filter((value) => {
							return value.replace(/^\s+|\s$/g, '') !== '';
						});
					}

					this.$apiClient.vote(uid, poll, votes).then(() => {
						this.sendingAnswers = false;
						this.sentAnswers = true;
					})
				} else if (confirmAnswers === false) {
					this.showConfirmScreen = false;
					this.showNoChoiceConfirmScreen = false;
					this.sendingAnswers = false;
					this.sentAnswers = true; // We "sent" the answers by confirming that we don't want to send the answers
				} else if (confirmAnswers === null) {
					// We simply hide the confirmation screen and such again
					this.showConfirmScreen = false;
					this.showNoChoiceConfirmScreen = false;
				}
			},
			onReachedEnd() {
				this.reachedEnd = true;
			},
			sendAnswers() {
				if (this.sentAnswers) {
					return;
				}

				this.showConfirmScreen = true;
			},
			setPollIndexByPollId(pollId) {
				this.$store.commit(MutationTypes.SET_CURRENT_POLL_ID, pollId);

				for (let i = 0, len = this.polls.length; i < len; i++) {
					if (this.polls[i].id === pollId) {
						this.currentPollIndex = i;

						break;
					}
				}

				this.sentAnswers = false;
				this.showNoChoiceConfirmScreen = false;
				this.showConfirmScreen = false;
			},
			onNewActivePoll(data) {
				this.setPollIndexByPollId(data.pollId);
			},
			onAcceptAnswersUpdated(data) {
				this.answersOpen = data.acceptAnswers;

				if (this.sentAnswers === false) {
					if (this.answersOpen) {
						this.showNoChoiceConfirmScreen = false;
						this.showConfirmScreen = false;
					} else {
						if (this.canSendAnswers) {
							// Yes, you've filled out some answers
							this.showNoChoiceConfirmScreen = true;
						} else {
							//this.sentAnswers = null; // Not actually true, but you didn't input any content
						}
					}
				} else if (this.sentAnswers === null && this.answersOpen) {
					// We didn't get time to respond but the question is open again
					this.showNoChoiceConfirmScreen = false;
					this.showConfirmScreen = false;
					this.sentAnswers = false;
				}
			},
		},
		watch: {
			currentPoll() {
				let options = {};
				let optionValues = {};
				let letters = 'ABCDEF';

				if (this.currentPoll.type === 'numeric') {
					for (let i = 0, len = this.currentPoll.options.length; i < len; i++) {
						let letter = letters[i];

						options[letter] = this.currentPoll.options[i];
						optionValues[letter] = 0;
					}
				} else if (this.currentPoll.type === 'freetext' || this.currentPoll.type === 'freetextWord') {
					for (let i = 0, len = letters.length; i < len; i++) {
						let letter = letters[i];

						options[letter] = null;
						optionValues[letter] = '';
					}
				}

				this.freetextCount = 1;

				this.options = options;
				this.optionValues = optionValues;

				this.showConfirmScreen = false;
				this.sentAnswers = false;
			},
			answersOpen() {
				if (this.answersOpen) {
					this.freetextCount = 1;
				}

				console.log('answersOpen', this.answersOpen);
			}
		}
	}
</script>

<style lang="scss" scoped>
	.freetext-container {
		textarea {
			resize: none;
		}
	}

	.header {
		color: #333333;
		font-size: 16pt;
		text-transform: uppercase;
		font-weight: bold;

		> div {
			margin: 0 auto;
			border-bottom: 4px solid black;
			padding-bottom: 5px;
			width: 70%;
		}
	}

	.question {
		font-weight: bold;
		font-size: 20pt;
		text-align: center;
		width: 100%;
		margin-left: -30px !important;
		margin-right: -30px !important;
	}

	.poll-key {
		font-size: 16pt;
		font-weight: bold;
	}

	.help-text {
		color: #888888;
		font-style: italic;
		font-size: 10pt;
		text-align: center;
		width: 100%;
	}

	.middle-text {
		position: fixed;
		top: 50%;
		left: 50%;
		margin: 0;
		transform: translate(-50%, -50%);

		font-weight: bold;
		text-align: center;
		font-size: 30pt;
	}

	.numeric-dropdown {
		height: 100%;
	}

	.question-text {
		line-height: 125%;
	}
</style>
